import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import {
  UpdateProjectNewBuildingDocument,
  ProjectPlanDocument,
  ProjectDocument,
  type UpdateProjectNewBuildingInput,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';
import requireValue from 'utils/requireValue';

const useUpdateProjectNewBuildingMutation = () => {
  const [updateProjectNewBuildingMutation] = useMutation(UpdateProjectNewBuildingDocument);

  const mutate = useCallback(
    async (projectId: string, formData: UpdateProjectNewBuildingInput) => {
      try {
        const res = await updateProjectNewBuildingMutation({
          variables: { projectId, formData: { ...formData } },
          refetchQueries: [
            { query: ProjectPlanDocument, variables: { projectId } },
            { query: ProjectDocument, variables: { id: projectId } },
          ],
          awaitRefetchQueries: true,
        });
        const { updateProjectNewBuilding: result } = requireValue(
          res.data,
          'updateProjectNewBuilding',
        );

        return result;
      } catch (error) {
        throw withRaw(toGraphqlError(error), error || '');
      }
    },
    [updateProjectNewBuildingMutation],
  );
  return mutate;
};

export default useUpdateProjectNewBuildingMutation;
